import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import {
  Radio,
  Paper,
  Tooltip,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import DoBarChart from "../DoBarChart";
import ComingSoon from "../../SKU-STO-Chart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import TableWithChart from "../LT_Capacity_Breach";
import AccuracyChart from "../AccuracyChart";
import { useAsyncError } from "react-router-dom";
import { setModuleTabIndex } from "../../../../store/Actions";
import AutoCompleteSearchField from "../AutoCompleteSearchField";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
    // marginRight: "100px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
}));

const dummyData = [
  {
    Network: "Ambient",
    Cost_Per_Case: 2.2350040995615656,
  },
  {
    Network: "Tempcontrolled",
    Cost_Per_Case: 2.0836020654393117,
  },
  {
    Network: "Frozen",
    Cost_Per_Case: 1.5215655528540184,
  },
  {
    Network: "Chilled",
    Cost_Per_Case: 1.2189636888844442,
  },
];

const getFilteredListByProperty = (list, property) => {
  return list?.some((item) => item?.hasOwnProperty(property))
    ? list?.map((item) => item[property]?.toString())?.filter(Boolean) // Only include non-null, non-undefined values
    : [];
};

const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];

const GraphView_Distribution_Planning = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  dateRangeDIP,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  //const networkOptions = ["AMBIENT", "CHILLED", "FROZEN", "NPW"];
  const allData = useSelector((state) => state);
  const dcOptions = getFilteredListByProperty(
    allData?.filter?.filteredList?.DC,
    "DC",
  );
  //const dcOptions = ["5722", "5222"];
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  const chartData = [];
  // const [yAxisTitle, setYAxisTitle] = useState('');
  // const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const topOrBottomValue = "Top";
  // const [countValue, setCountValue] = useState("5");
  const countValue = "5";
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue,
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  // const storeData = useSelector((state) => state);
  const [expansionGraphData, setExpansionGraphData] = useState([]);
  const [entityAndThreshold, setEntityAndThreshold] = useState([]);
  const [updateThreshold, setUpdateThreshold] = useState(false);
  const [entityName, setEntityName] = useState("");
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [duration, setDuration] = useState(4);
  const [isPrevMonth, setIsPrevMonth] = useState(false);
  const [metricName, setMetricName] = useState("Network");
  const [metricOptions, setMetricOptions] = useState(networkOptions);
  const [selectedMetricOption, setSelectedMetricOption] = useState("AMBIENT");
  const [dollarValue, setDollarValue] = useState("Inv.On Hand Dollars");
  const [value, setValue] = React.useState([networkOptions[0]]);
  //const [selectedMetricOption, setSelectedMetricOption] = useState(activeTab === "Bias" ? [networkOptions[0]] : []);
  const [selectedDivisionOptions, setSelectedDivisionOptions] = useState([]);
  const [selectedPL3Options, setSelectedPL3Options] = useState([]);
  const [pl3Options, setPL3Options] = useState([]);
  const [divisionOptions, setDivisonOptions] = useState([]);
  const [selectedNetwork, setSeletedNetwork] = useState("AMBIENT");

  const radioOptions = () => {
    if (activeTab === "Inv. On Hand") {
      return ["Network", "Division", "DC"];
    }
    if (activeTab === "Waste Risk") {
      return ["Network", "Division", "DC"];
    }
    if (activeTab === "COF") {
      return ["Network"];
    }
    if (activeTab === "LT Capacity Breach") {
      return [];
    }
    if (activeTab === "Dock Utilization") {
      return ["Overall", "Network"];
    }
    if (activeTab === "Bias") {
      return ["Outbound", "Inbound", "Customer Order"];
    }
  };

  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions() === "Network" ? "Network" : radioOptions()[0],
  );

  const getGraphData = (params) => {
    if (activeTab !== "LT Capacity Breach") {
      setGraphData([]);
    }
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          if (entityName) {
            setExpansionGraphData([...data?.data]);
          } else {
            setGraphData([...data?.data]);
          }
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        setLoading(false);
        setEntityAndThreshold([]);
        setUpdateThreshold(false);
      });
  };

  const memoizedParams = useMemo(() => {
    let params = {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis: activeTab === "Bias" ? metricName : selectedRadioValue,
      Week_count: duration,
      start_Date: new Date(startDate).toLocaleDateString("en-CA"),
      //start_Date: "2024-12-01",
      end_Date: new Date(endDate).toLocaleDateString("en-CA"),
      //end_Date: "2025-06-01",
      Level: role,
      filter: {
        RecommendedDC:
          activeTab === "Bias"
            ? metricName === "DC"
              ? value?.map((item) => item.value)
              : []
            : DC,
        Network:
          activeTab === "Bias"
            ? metricName === "Network"
              ? value?.map((item) => item.value)
              : []
            : ["Inv. On Hand", "Waste Risk"]?.includes(activeTab)
              ? [selectedNetwork]
              : Network,
        PL3: ["Inv. On Hand", "Waste Risk"]?.includes(activeTab)
          ? selectedPL3Options?.map((data) => data?.value)
          : PL3,
        Division: ["Inv. On Hand", "Waste Risk"]?.includes(activeTab)
          ? selectedDivisionOptions?.map((data) => data?.value)
          : Division,
        startDate: dateRangeDIP?.[0],
        endDate: dateRangeDIP?.[1],
      },
    };
    if (updateThreshold) {
      params.user_threshold = entityAndThreshold;
    }
    if (entityName) {
      params.flag = true;
      params.Entity_name = entityName;
    }
    if (activeTab === "Inv. On Hand") {
      params.units = dollarValue;
      params.type = dollarValue;
    }
    if (activeTab === "Dock Utilization") {
      params.isPreviousMonth = isPrevMonth;
    }
    if (activeTab === "Bias") {
      if (selectedRadioValue === "Outbound") {
        params.KPI = "DC to DC Outbounds";
      } else if (selectedRadioValue === "Inbound") {
        params.KPI = "DC Inbounds";
      } else if (selectedRadioValue === "Customer Order") {
        params.KPI = "DC to Customer Outbounds";
      }
    }
    return params;
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    dateRangeDIP,
    startDate,
    endDate,
    duration,
    updateThreshold,
    entityName,
    isPrevMonth,
    metricName,
    selectedMetricOption,
    dollarValue,
    value,
    selectedDivisionOptions,
    selectedPL3Options,
    selectedNetwork,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const getMapedDCData = () => {
    const params = {
      Network: allData.filter.Network,
    };
    GraphService.getMapedDC(params, instance)
      .then((data) => {
        if (data?.data) {
          const dcData = data?.data?.map((item) => ({
            entity: "DC",
            value: item?.LocationId,
          }));
          setMetricOptions([...dcData]);
          setValue([dcData[0]]);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const getMappedData = () => {
    const params = {
      Network: [selectedNetwork],
    };
    GraphService.getMapedDataForFGS(params, instance)
      .then((data) => {
        if (data?.data) {
          const divisionData = data?.data[0].Division.map((item) => ({
            entity: "Division",
            value: item,
          }));
          const PL3Data = data?.data[0].ProductLevel3CategoryDescription.map(
            (item) => ({
              entity: "ProductLevel3CategoryDescription",
              value: item,
            }),
          );
          setDivisonOptions([...divisionData]);
          setPL3Options([...PL3Data]);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    if (metricName === "DC") {
      getMapedDCData();
    } else {
      if (allData.filter.Network.length > 0) {
        let data = [];

        allData?.filter?.Network?.forEach((item) => {
          data.push({ entity: "Network", value: item });
        });
        setValue([...data]);
      } else {
        setValue([networkOptions[0]]);
      }
      setMetricOptions([...networkOptions]);
    }
  }, [metricName]);

  useEffect(() => {
    if (allData.filter.Network.length > 0) {
      let data = [];

      allData?.filter.Network?.forEach((item) => {
        data.push({ entity: "Network", value: item });
      });
      setValue([...data]);
    }
    getMappedData();
  }, []);

  useEffect(() => {
    setSelectedDivisionOptions([]);
    setSelectedPL3Options([]);
  }, [selectedNetwork]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue(newValue === 5 ? "Outbound" : "Network");
    setSeletedNetwork("AMBIENT");
  };

  const handleSelectedNetwork = (event) => {
    setSeletedNetwork(event.target.value);
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleDurationChange = (event) => {
    setDuration(event.target.value);
  };

  const handleMonthChange = (event) => {
    setIsPrevMonth(event.target.value);
  };

  const handleMetricNameChange = (event) => {
    setMetricName(event.target.value);
  };

  // const handleSelectMetricOption = (value) => {
  //     setSelectedMetricOption(value);
  // }

  const handleDollarValueChange = (event) => {
    setDollarValue(event.target.value);
  };

  const renderChart = () => {
    const chartProps = {
      graphData,
      chartData,
      categoryList,
      showAnnotation: true,
    };
    if (activeTab === "LT Capacity Breach") {
      return (
        <TableWithChart
          activeTab={activeTab}
          graphData={
            entityName ? [graphData[currentRowIndex]] : graphData || []
          }
          expansionGraphData={expansionGraphData}
          showGraph={showGraph}
          setShowGraph={setShowGraph}
          entityAndThreshold={entityAndThreshold}
          setEntityAndThreshold={setEntityAndThreshold}
          updateThreshold={updateThreshold}
          setUpdateThreshold={setUpdateThreshold}
          entityName={entityName}
          setEntityName={setEntityName}
          currentRowIndex={currentRowIndex}
          setCurrentRowIndex={setCurrentRowIndex}
        />
      );
    } else if (activeTab === "Dock Utilization") {
      return <GroupedBarMultipleLineChart {...chartProps} />;
    } else if (activeTab === "Bias") {
      return (
        <AccuracyChart
          graphData={graphData}
          showAnnotation={false}
          activeTab={activeTab}
        />
      );
    } else {
      return (
        <BarChart
          {...chartProps}
          yAxisTitle={activeTab === "COF" ? "Fullfillment%" : activeTab}
          activeTab={activeTab}
          showAnnotation={activeTab === "COF" ? true : false}
          type={activeTab === "Inv. On Hand" ? dollarValue : Module}
        />
      );
    }
  };

  useEffect(() => {
    const today = dayjs(); // Get today's date as a Dayjs object
    setStartDate(today);

    const nextMonth = today.add(1, "month"); // Add one month to today's date
    setEndDate(nextMonth);
  }, []);

  useEffect(() => {
    if (metricName === "Network") {
      setMetricOptions([...networkOptions]);
      setSelectedMetricOption(networkOptions[0]);
    } else {
      setMetricOptions([...dcOptions]);
      setSelectedMetricOption(dcOptions[0]);
    }
  }, [metricName]);

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "10px",
                      flexWrap: "wrap",
                      marginLeft: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        rowGap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {activeTab === "LT Capacity Breach" && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#aaaaaaff",
                                mb: "4px",
                                marginLeft: "18px",
                              }}
                            >
                              Duration
                            </Typography>

                            <Select
                              value={duration}
                              onChange={handleDurationChange}
                              className={classes.select}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={classes.select}
                            >
                              {countList.map((item, _index) => (
                                <MenuItem key={item} value={item}>
                                  {item} Weeks
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        </div>
                      )}

                      {(activeTab === "Inv. On Hand" ||
                        activeTab === "Waste Risk") && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            rowGap: "10px",
                          }}
                        >
                          <div style={{ alignSelf: "flex-end" }}>
                            <Select
                              value={selectedNetwork}
                              onChange={handleSelectedNetwork}
                              className={classes.select}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={{ ...classes.select }}
                            >
                              {networkOptions?.map((option) => {
                                return (
                                  <MenuItem value={option?.value}>
                                    {option?.value}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </div>
                          <div style={{ marginLeft: "18px" }}>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#aaaaaaff",
                                mb: "4px",
                              }}
                            >
                              Select Division
                            </Typography>
                            <AutoCompleteSearchField
                              selectedMetricOptions={selectedDivisionOptions}
                              setSelectedMetricOptions={
                                setSelectedDivisionOptions
                              }
                              metricOptions={divisionOptions}
                              style={{ width: "265px" }}
                            />
                          </div>
                          <div style={{ marginLeft: "18px" }}>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#aaaaaaff",
                                mb: "4px",
                              }}
                            >
                              Select PL3
                            </Typography>
                            <AutoCompleteSearchField
                              selectedMetricOptions={selectedPL3Options}
                              setSelectedMetricOptions={setSelectedPL3Options}
                              metricOptions={pl3Options}
                              style={{ width: "265px", alignSelf: "flex-end" }}
                            />
                          </div>
                        </div>
                      )}
                      {activeTab === "Dock Utilization" && (
                        <>
                          <Select
                            value={isPrevMonth}
                            onChange={handleMonthChange}
                            className={classes.select}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            sx={{ ...classes.select, width: "125px" }}
                          >
                            <MenuItem value={false}>This Month</MenuItem>
                            <MenuItem value={true}>Last Month</MenuItem>
                          </Select>
                        </>
                      )}
                      {activeTab === "Bias" && (
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                          <div>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#aaaaaaff",
                                mb: "4px",
                                marginLeft: "18px",
                              }}
                            >
                              By
                            </Typography>
                            <Select
                              value={metricName}
                              onChange={handleMetricNameChange}
                              className={classes.select}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={{ ...classes.select }}
                            >
                              <MenuItem value={"Network"}>Network</MenuItem>
                              <MenuItem value={"DC"}>DC</MenuItem>
                            </Select>
                          </div>
                          <div>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#aaaaaaff",
                                mb: "4px",
                              }}
                            >
                              {metricName === "Network"
                                ? "Select Network"
                                : "Select DC"}
                            </Typography>
                            <AutoCompleteSearchField
                              selectedMetricOptions={value}
                              setSelectedMetricOptions={setValue}
                              metricOptions={metricOptions}
                              placeholderName={
                                metricName === "Network"
                                  ? "Select Network"
                                  : "Select DC"
                              }
                              style={{ width: "230px" }}
                            />
                          </div>
                        </div>
                      )}
                      {activeTab === "Inv. On Hand" && (
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "4px",
                              marginLeft: "18px",
                            }}
                          >
                            Units
                          </Typography>
                          <Select
                            value={dollarValue}
                            onChange={handleDollarValueChange}
                            className={classes.select}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            sx={classes.select}
                          >
                            <MenuItem value={"Inv.On Hand Dollars"}>
                              Dollar
                            </MenuItem>
                            <MenuItem value={"Inv.On Hand DOH"}>DOH</MenuItem>
                          </Select>
                        </div>
                      )}
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                      {radioOptions().map((option) => (
                        <React.Fragment key={option}>
                          <Radio
                            value={option}
                            checked={selectedRadioValue === option}
                            onChange={() => handleRadioChange(option)}
                            size="small"
                            inputProps={{ "aria-label": option }}
                            sx={{
                              color: "#359DD0 !important",
                              "&.Mui-checked": {
                                color: "#359DD0 !important",
                              },
                            }}
                          />
                          <span
                            className={classes.filter}
                            style={{
                              color:
                                selectedRadioValue ===
                                (Module === "SNO" ? "Overall" : "Network")
                                  ? "#359DD0"
                                  : "#359DD0",
                            }}
                          >
                            {option}
                          </span>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphView_Distribution_Planning.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  dateRangeDIP: state.filter.dateRangeDIP,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GraphView_Distribution_Planning);
